// extracted by mini-css-extract-plugin
export default {"root":"_2TZrZ","warning":"_20MdW"};